import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false
})
export class ToggleComponent {

    // Inputs.
    @Input() left: string | null = null;
    @Input() right: string | null = null;
    @Input() value: string;
    @Input() disabled: boolean = false;

    // Outputs.
    @Output() valueChange = new EventEmitter<string>();

}
